import { StyleSheet, View } from 'react-native'

import { LoadingSpinner } from '../components/LoadingSpinner'
import { useFlowStepFrame } from '../hooks/useNestedSheetHeight'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { useTheme } from '../theme/restyle'

const SPINNER_SIZE = 48
// Long enough that a warm lookup — the normal case — draws nothing at all.
const SPINNER_DELAY_MS = 400

/**
 * Held while the region verdict is still provisional.
 *
 * Nothing of the deposit mounts behind this. Mounting the amount screen first
 * and swapping it out on a refusal would let the buyer start typing into a
 * flow that was never open to them, and would report the deposit `cancelled`
 * on the way out — on top of the refusal the host is about to hear.
 */
export function FiatRegionPendingStep() {
  const theme = useTheme()
  const { t } = useFunkitTranslation()
  const { height } = useFlowStepFrame()
  return (
    <View
      accessibilityRole="progressbar"
      accessibilityLabel={t('common.loading')}
      style={[styles.frame, { height }]}
    >
      <LoadingSpinner
        size={SPINNER_SIZE}
        color={theme.brand.primary}
        delay={SPINNER_DELAY_MS}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  frame: { alignItems: 'center', justifyContent: 'center' },
})
